import { indexData } from '@/mocks/homepage';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-book-open-line text-sm"></i>
            </div>
            影视索引
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            快速找到你想看的
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            电影大全分类导航，电视剧全集和最新影视一触即达
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-6">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-200 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <div>
                <h3 className="text-base font-bold text-foreground-900 font-heading mb-1 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 mb-1">{item.desc}</p>
                <span className="text-xs text-foreground-500 font-mono">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}